import { render, staticRenderFns } from "./edit-sign.vue?vue&type=template&id=f35b0f64&scoped=true&"
import script from "./edit-sign.vue?vue&type=script&lang=js&"
export * from "./edit-sign.vue?vue&type=script&lang=js&"
import style0 from "./edit-sign.vue?vue&type=style&index=0&id=f35b0f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35b0f64",
  null
  
)

export default component.exports